/**
 * VoiceList Component
 *
 * Renders a grid of VoiceCard components for all
 * cloned voices belonging to the current user.
 */

import { Loader2 } from 'lucide-react';
import { VoiceCard } from './VoiceCard';
import type { IVoiceListProps } from '@/@types/voices';
import type { Id } from '../../../convex/_generated/dataModel';

function VoiceList({
  voices,
  selectedVoiceId,
  onSelectVoice,
  onDeleteVoice,
  onRefreshPreview,
  refreshingVoiceId,
  isLoading,
  onEditSettings,
}: IVoiceListProps & {
  onEditSettings?: (voiceId: Id<'clonedVoices'>) => void;
}) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 text-blue-500 animate-spin" />
      </div>
    );
  }

  if (voices.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {voices.map(voice => (
        <VoiceCard
          key={voice._id}
          voice={voice}
          isSelected={selectedVoiceId === voice._id}
          onSelect={onSelectVoice}
          onDelete={onDeleteVoice}
          onEditSettings={onEditSettings}
          onRefreshPreview={onRefreshPreview}
          isRefreshingPreview={refreshingVoiceId === voice._id}
        />
      ))}
    </div>
  );
}

export { VoiceList };
